import styled from "styled-components";
import { useState, useContext, useEffect } from "react";

const InputWrapper = styled.div`
  width: fit-content;
  height: 44px;
  border-radius: 6px;
  border: 1px solid #498ca646;
  display: flex;
  overflow: hidden;

  .buttons {
    display: flex;
    flex-direction: column;
    width: 46px;
  }
  input {
    height: 100%;
    width: 80px;
    appearance: none;
    border: none;
    text-align: center;
    font-size: 16px;
    font-weight: 200;
  }
  button {
    width: 46px;
    height: 50%;
    color: white;
    border: none;
    background-color: var(--accent-color-dark);
    font-size: 1.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  button:hover {
    filter: brightness(90%);
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default function NumberInput(props: Props) {
  const [inputValue, setInputValue] = useState(props.value);

  useEffect(() => {
    setInputValue(props.value);
  }, [props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setInputValue(value);
    }else{
        setInputValue(0);
    }
  };

  const handleBlur = () => {
    if (inputValue >= 0) {
      props.onValueChange(inputValue);
    }
  };

  const moreOrLess = (e: React.MouseEvent<HTMLButtonElement>) => {
    const increment = e.currentTarget.classList.contains("more") ? 1 : -1;
    const newValue = props.value + increment;
    if (newValue >= 0) {
      props.onValueChange(newValue);
    }
  };

  return (
    <InputWrapper>
      <input
        type="tel"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <div className="buttons">
        <button className="more" onClick={moreOrLess}>
          <i className="pi pi-angle-up"></i>
        </button>
        <button className="less" onClick={moreOrLess}>
          <i className="pi pi-angle-down"></i>
        </button>
      </div>
    </InputWrapper>
  );
}

interface Props {
  value: number;
  onValueChange: (value: number) => void;
}
